import { render, staticRenderFns } from "./DashBoardProcessamento.vue?vue&type=template&id=cb2e093a&"
import script from "./DashBoardProcessamento.vue?vue&type=script&lang=js&"
export * from "./DashBoardProcessamento.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardProcessamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports